// Canonical English values: they travel to the kitchen ticket and are matched by the
// backend (ALLERGEN_SYNONYMS + term matching in backend/auto_plate.py). Labels live in
// the i18n catalogs under allergens.<key>. Keep the two lists consciously aligned.
//
// Order is deliberate: the EU-14 declarable allergens first, then the extension —
// AllergyPicker renders (and serializes known tokens) in this order.
export const ALLERGENS = [
  { key: "gluten", value: "Gluten" },
  { key: "milk", value: "Milk" },
  { key: "eggs", value: "Eggs" },
  { key: "peanuts", value: "Peanuts" },
  { key: "tree_nuts", value: "Tree nuts" },
  { key: "soy", value: "Soy" },
  { key: "fish", value: "Fish" },
  { key: "crustaceans", value: "Crustaceans" },
  { key: "molluscs", value: "Molluscs" },
  { key: "celery", value: "Celery" },
  { key: "mustard", value: "Mustard" },
  { key: "sesame", value: "Sesame" },
  { key: "sulphites", value: "Sulphites" },
  { key: "lupin", value: "Lupin" },
  { key: "coconut", value: "Coconut" },
  { key: "corn", value: "Corn" },
  { key: "citrus", value: "Citrus" },
  { key: "strawberry", value: "Strawberry" },
  { key: "kiwi", value: "Kiwi" },
  { key: "banana", value: "Banana" },
  { key: "avocado", value: "Avocado" },
  { key: "honey", value: "Honey" },
  { key: "cocoa", value: "Cocoa" },
  { key: "garlic", value: "Garlic" },
  { key: "onion", value: "Onion" },
];

/**
 * The tokens inside the comma-joined string the picker stores.
 *
 * Both the guest's welcome-screen field and the account profile hold the same
 * shape, and the plate builder has to send whichever is there — including a
 * legacy token somebody typed before the list existed, because that is still
 * safety information.
 */
export const parseAllergyTokens = (value) =>
  String(value || "")
    .split(",")
    .map((token) => token.trim())
    .filter(Boolean);
